import { useMutation } from 'react-query';
import { Http } from '../../services/Http';
import { AddUserPayload, User } from '../../types';
import { MUTATION_KEYS } from '../constants';
import { useInvalidateUsers } from './useUsers';
import { useInvalidateDeals } from './useDeals';

type Props = {
  payload: AddUserPayload;
};

async function addUser({ payload }: Props): Promise<User> {
  const { data } = await Http.axios.post<AddUserPayload, User>('user', payload);
  return data;
}

export const useAddUser = () => {
  const invalidateUsers = useInvalidateUsers();
  const invalidateDeals = useInvalidateDeals();

  return useMutation(addUser, {
    mutationKey: MUTATION_KEYS.ADD_USER_KEY,
    onSuccess: () => {
      invalidateUsers();
      invalidateDeals();
    },
  });
};
